import React from 'react';
import { playButton } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Warning',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'warning',
  icon: {
    baseShape: playButton,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'important-alerts',
    order: 35,
  },
  standardMarkerOptions: {
    markerType: 'warningMarker',
    allowCreation: false,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Warning',
      itemTitleFunction: (item) => (item && item.title) || 'Warning',
    },
    creationOptions: {
      menuText: '',
      newTitle: '',
      titlePlaceholder: 'Title',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker can indicate a range of different hazards. Include
          information such as type of hazard and important observations.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          This marker can indicate a range of different hazards. Include
          information such as type of hazard and important observations.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: false,
    displayUpVotes: false,
    title: 'Warning',
    description: 'Warning in area, please read the following information',
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);
// layer.onMapClickEvent = showPopOverFromEvent(layer);

export default layer;
